import React from "react";
import { Colors, TextFont } from "../../../config";

const HeaderText = ({ label }) => {
  return (
    <TextFont fontColor={Colors.gullGray} fontSize="1rem">
      {label}
    </TextFont>
  );
};

export default HeaderText;
